<template>
  <div id='questionDetail2'>
       <!-- 单选题 -->
	    <div v-if='msgTest' class='teshutishi'>{{msg}}</div>
        <div class='title'>{{Qs.title}}</div>
        <div class='title2'>{{Qs.question_desc}}</div> 
		
        <div class="radio"  :class='item.checked?"checked":""'  v-for='(item,index) in  Qs.answer' :data-inx="index"  @click='handleQuestion($event)'>
          <img src="../assets/icon-check.png" v-show='!item.checked' :data-inx="index"/>
          <img src="../assets/icon-checked.png" v-show='item.checked' :data-inx="index"/>
          <span :data-inx="index">{{item.item}}</span>
        </div>

      
       
  </div>
</template>

<script>
export default {
  name: 'Q2',
  props: {
    Q: Object,
    fn: Function
  },
  data:function () {
    return{
        Qs:{},
        dianMark:true,
		msg:"",
		msgTest:false,
    }
  },
  created:function(){
     this.Qreset()
	 this.$parent.goOnQuestion()
	 this.msgTest = false
  },
  watch:{
    Q:{
        handler(newValue, oldValue) {
　　　　　　this.Qreset()
　　　　},
    }
  },
  methods: {
   handleQuestion(e) {
	   console.log(e.srcElement.dataset.inx)
      if(!this.dianMark)return
      let _Qs = this.Qs
      let _ids=[]
	  this.msgTest=false
      _Qs.answer.forEach((item,index,)=>{
        item.checked =false
        if(index == e.srcElement.dataset.inx){
			if (item.group == 0) {   //检查当前选择是否为中断组
				  this.msg=item.msg
				  this.msgTest=true
			}
          item.checked =true
          _ids[0] = item.id
        }
        
      })
	  
	  if(this.msgTest){
		 
		  return
	  }
	
      this.Qs = Object.assign({},_Qs)

      let _questions=this.$store.state.questions
        _questions.is_up = 0
        _questions.record_id = this.Q.record_id
        _questions.member_id = this.$store.state.member_id
        _questions.question ={
                              question_id:this.Qs.id,
                              answer_ids:_ids,
                              answer:""
                            }
   
        this.$store.commit("modifyQuestions",_questions)
        this.fn()
        this.dianMark = false
		this.msgTest = false
        setTimeout(()=>{
        this.Qreset()
        },1000)
        
   },
   // 选择重置
   Qreset(){
          let _Q = this.Q
          _Q.answer.forEach((item,index)=>{
            item.checked =false
          })
          this.Qs = _Q
          this.dianMark = true
    },
  },

}
</script>  

<style>
#questionDetail2{
   width: 7.5rem;
  padding-top:1.14rem;
  padding-bottom: 2rem;
  overflow-y: scroll;
  height: 100vh;
  box-sizing: border-box;

}
#questionDetail2::-webkit-scrollbar {display:none}
#questionDetail2 .title{
  text-align:center;
  min-height:0.7rem;
  font-size:0.42rem;
  font-family:SourceHanSansCN-Medium;
  font-weight:600;
  letter-spacing:0.01rem;
  color:rgba(20,20,20,1);
  line-height:0.7rem;
  padding:0 0.9rem; 
}
#questionDetail2 .title2{
   text-align: center;
    color: #727171;
    font-weight: normal;
    font-size: 0.3rem;
    margin: 0.075rem 0 0.6rem;
    padding:0 0.9rem; 
} 
#questionDetail2 .qInput{
    height: 1.2rem;
    width: 6rem;
    box-sizing: border-box;
    background: #fff;
    border-radius: 0.1rem;
    padding: 0.28rem;
    margin:0 auto 0.4rem;
    text-align: center;
    font-size: 0.45rem;
    box-shadow: 0px 20px 50px -20px rgba(236, 163, 129, 0.5);
    outline: none;
    border:none;
}
#questionDetail2 .radio{
    background: #fff;
    display: flex;
    align-items: center;
    padding: 0.375rem;
    border-radius: 5px;
    color: #141414;
    text-align:left;
    margin:0 0.75rem 0.375rem;
    height: 1.2rem;
    box-sizing: border-box;
}
#questionDetail2 .radio img{
    width:0.64rem;
    height: 0.64rem;
}
#questionDetail2 .radio span{
  margin-left: 0.375rem;
  font-size: 0.32rem;
  flex:1;
}
#questionDetail2 .checked {
    background:rgba(224, 227, 222, 1);
}
.teshutishi{
  position: fixed;
  transform: translate(-50%, 0); 
  top: 0.08rem;
  left: 50%;
  width: 7.5rem;
  height: 0.48rem;
  background-color: #C25E4D;
  color: #fff;
  text-align: center;
  font-size: 0.24rem;
  line-height: 0.48rem;
  z-index: 99;
}
</style>